import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import { MapService } from 'src/app/Service/map.service';
import Feature from 'ol/Feature';
import { Icon, Style } from 'ol/style';
import { BingMaps, XYZ } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import * as olProj from 'ol/proj';
import { Point } from 'ol/geom';
import Vector from 'ol/source/Vector';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

declare let $: any;

@Component({

  selector: 'app-service-area',

  templateUrl: './service-area.component.html',

  styleUrls: ['./service-area.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ServiceAreaComponent implements OnInit {

  serviceAreas: any;

  searchFilter: any;

  source: any;

  vector: any;

  map: any;

  mapEditType: number = 0;

  layers: any = [];

  list_City: any[] = [];

  list_Search: any[] = [];

  filteredCity: any = [];

  editMode: boolean = false;

  searchT_City = '';

  latoLong: FormGroup = this.formBuilder.group({
    latIn: new FormControl(''),
    longIn: new FormControl('')
  })

  SAInputs: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(''),
    strSession: new FormControl(''),
    strComment: new FormControl(''),
    strTripRequestEndTime: new FormControl(''),
    iRadious: new FormControl(''),
    iParkingRadious: new FormControl(''),
    iMissionRadious: new FormControl(''),
    iMobileDomain: new FormControl(''),
    fLat: new FormControl(''),
    fLon: new FormControl(''),
    fCityLat: new FormControl(''),
    fCityLon: new FormControl(''),
    strTerminalID: new FormControl(''),
    strBankName: new FormControl(''),
    tiCommission: new FormControl(''),
    strSchoolBusMedia: new FormControl(''),
    strCity: new FormControl(''),
    Expr1: new FormControl(''),
  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private location: Location,

    private el: ElementRef,

    private otherService: OtherService,

    private mapService: MapService,

    private notificationService: NotificationService,

    private gurdService: GurdServiceService,

    private formBuilder: FormBuilder

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });

    this.getListOfServiceArea();

    this.getListCity();

    this.SAInputs.controls['iSystemUser'].setValue(this.gurdService.decrypt(localStorage.getItem('ID')!))

    this.SAInputs.controls['strSession'].setValue(this.gurdService.decrypt(localStorage.getItem('Session')!))

  }

  confirmLatol(data: any) {
    if (data == 0) {
      this.SAInputs.controls['fLat'].setValue(this.latoLong.get('latIn')?.value);
      this.SAInputs.controls['fLon'].setValue(this.latoLong.get('longIn')?.value);


    } else {
      this.SAInputs.controls['fCityLat'].setValue(this.latoLong.get('latIn')?.value);
      this.SAInputs.controls['fCityLon'].setValue(this.latoLong.get('longIn')?.value);
    }

    this.latoLong.get('latIn')?.setValue('');
    this.latoLong.get('longIn')?.setValue('');
    $('#maplat').modal('hide');

  }

  newOpenMap = async (data: any) => {
    this.mapEditType = data;

    $('#maplat').modal('show');

    setTimeout(() => {
      if (this.map || this.mapEditType != this.mapEditType) {
        this.map.setTarget(null);
      }
      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({
        source: this.source,
      });

      var iconStyle = new Style({
        image: new Icon(({
          anchor: [0, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          size: [48, 48],
          opacity: 1,
          src: '../../assets/Img/marker4.png'
        }))
      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }

      if (this.latoLong.get('latIn')?.value != '' && this.latoLong.get('longIn')?.value != '') {
        this.map = new Map({
          layers: this.layers,
          target: 'map',
          view: new View({
            center: olProj.fromLonLat([this.latoLong.get('longIn')?.value, this.latoLong.get('latIn')?.value]),
            zoom: 18,
          }),
        });
        var iconGeometry = new Point(olProj.fromLonLat([this.latoLong.get('longIn')?.value, this.latoLong.get('latIn')?.value]))

        var iconFeature = new Feature({
          geometry: iconGeometry,
        });

        iconFeature.setStyle(iconStyle);
        var vectorSource = new Vector({
          features: [iconFeature]
        });

        var dinamicPinLayer = new VectorLayer({
          source: vectorSource
        });

        this.map.addLayer(dinamicPinLayer);

      } else {
        this.map = new Map({
          layers: this.layers,
          target: 'map',
          view: new View({
            center: olProj.fromLonLat([51.3833554, 35.6770113]),
            zoom: 13,
          }),
        });
      }



      this.map.on('click', (e: any) => {
        if (e.dragging)
          return;

        var coords = olProj.toLonLat(e.coordinate);
        this.latoLong.controls['latIn'].setValue(coords[1])
        this.latoLong.controls['longIn'].setValue(coords[0])
        var iconGeometry = new Point(e.coordinate)
        var iconFeature = new Feature({
          geometry: iconGeometry,
        });

        iconFeature.setStyle(iconStyle);
        var vectorSource = new Vector({
          features: [iconFeature]
        });

        var dinamicPinLayer = new VectorLayer({
          source: vectorSource
        });

        this.map.getLayers().forEach((layer: VectorSource) => {
          if (layer.getKeys().length < 11)
            this.map.removeLayer(layer);
        });

        this.map.addLayer(dinamicPinLayer);
      })

      this.map.on('pointermove', (e: any) => {
        var pixel = this.map.getEventPixel(e.originalEvent);
        var hit = this.map.hasFeatureAtPixel(pixel);
        this.map.getViewport().style.cursor = 'pointer';
      });

    }, 500);
  }

  openEditModal(item: any) {

    Object.keys(item).forEach(key => {
      this.SAInputs.get(key)?.setValue(item[key])
    })

    this.latoLong.controls['latIn'].setValue(this.SAInputs.get('fLat')?.value);
    this.latoLong.controls['longIn'].setValue(this.SAInputs.get('fLon')?.value);
  }

  async DeleteSA(item: any) {
    $.confirm({
      title: `آیا از حذف این حوزه خدمت اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
              iMobileDomain: item.iMobileDomain
            };


            let res = JSON.parse((await axios.post(`MobileDomain_Delete`, model)).data.toString());
            if (res.iResult == 0)
              return this.notificationService.showError(res.strError);

            this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
            this.getListOfServiceArea();
          }
        },
        cancel: {
          text: "لغو",
        }
      }
    });
  }

  addSa() {
    this.SAInputs.reset();
  }

  async EditSA() {

    let Stime = (document.getElementById('Stime') as any).value;

    this.SAInputs.controls['iSystemUser'].setValue(this.gurdService.decrypt(localStorage.getItem('ID')!))

    this.SAInputs.controls['strSession'].setValue(this.gurdService.decrypt(localStorage.getItem('Session')!))

    this.SAInputs.controls['strTripRequestEndTime'].setValue(Stime)

    if (this.editMode) {

      let resp = JSON.parse((await axios.post(`MobileDomain_Edit`, this.SAInputs.value)).data.toString());

      if (resp.iResult == 0) return this.notificationService.showError(resp.strError)

      this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');

      this.getListOfServiceArea();


    } else {
      let resp = JSON.parse((await axios.post(`MobileDomain_Save`, this.SAInputs.value)).data.toString());
      if (resp.iResult == 0)
        return this.notificationService.showError(resp.strError)

      this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
      this.getListOfServiceArea();
    }

    this.SAInputs.reset();
    $('#editSA').modal('hide');
  }

  async getListOfServiceArea() {
    let res = JSON.parse((await axios.post(`MobileDomain_List`, {})).data.toString());
    this.serviceAreas = res;
  }

  getListCity = async () => {

    this.otherService.Showspinner()

    let res = JSON.parse((await axios.post(`City_List`, this.otherService.stringNumberToNumber(this.SAInputs.value))).data.toString());

    this.otherService.nonespinner()

    this.list_City = res;

    this.list_Search = res;

  }

  hideCity_Option() {

    setTimeout(() => {

      this.filteredCity = [];

    }, 300);
  }

  selectedCity(item: any) {

    this.SAInputs.controls['strCity'].setValue(item.strCity)

    this.searchT_City = item.strCityName;

    this.filteredCity = [];

  }

  filterCity() {

    if (this.searchT_City == '') {

      this.filteredCity = [];

      this.SAInputs.controls['strCity'].setValue('')

    }

    else this.filteredCity = this.list_City.filter((item: any) => item.strCityName.includes(this.searchT_City));

  }

  sortBy(input: any) {

    if (this.serviceAreas.length > 0) {

      this.serviceAreas.sort((a: any, b: any) => {

        if (input == 0) {
          var textA = a.strComment.toUpperCase();
          var textB = b.strComment.toUpperCase();
        }

        if (input == 1) {
          var textA = a.Expr1;
          var textB = b.Expr1;
        }

        if (input == 2) {
          var textA: any = Number(a.iRadious);
          var textB: any = Number(b.iRadious);
        }

        if (input == 3) {
          return a.fLat - b.fLat;
        }

        if (input == 4) {
          return a.fLon - b.fLon;
        }

        if (textA > textB)
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;

        if (textA < textB)
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

        return

      })

    }

  }

  searchbox(value: any) {

    if (!this.searchFilter) {

      this.searchFilter = this.serviceAreas;

    }

    if (value.length == 0) {

      this.serviceAreas = this.searchFilter;

      this.searchFilter = false;

    }
    else {

      this.serviceAreas = this.searchFilter.filter((x: any) => x.strComment.startsWith(value) || x.Expr1.startsWith(value))

    }

  }

  goBack() {
    this.location.back();
  }

}